/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Why_Quote_PreInputs */

const en_dr_why_quote_pre = /** @type {(inputs: Dr_Why_Quote_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your workshop can stay in`)
};

const id_dr_why_quote_pre = /** @type {(inputs: Dr_Why_Quote_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workshop-mu boleh tetap di`)
};

/**
* | output |
* | --- |
* | "Your workshop can stay in" |
*
* @param {Dr_Why_Quote_PreInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_why_quote_pre = /** @type {((inputs?: Dr_Why_Quote_PreInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Why_Quote_PreInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_why_quote_pre(inputs)
	return en_dr_why_quote_pre(inputs)
});